'use client';

import { Link } from '@/i18n/routing';
import Image from '@/components/shared/Image';
import { SectionLabel } from '@/components/shared/SectionLabel';
import { useTranslations } from '@/i18n/intl';

export function CareerSection() {
  const t = useTranslations('Career');

  return (
    <section className="py-10 md:py-[72px] px-5 md:px-[40px] bg-navy">
      <div className="max-w-[1170px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Left: Image */}
        <div className="aspect-[4/3] rounded-lg overflow-hidden">
          <Image
            src="/images/simisi/page16_img1.png"
            alt="Work with Simisi&Co."
            width={631}
            height={400}
            className="w-full h-full object-cover"
          />
        </div>

        {/* Right: Text */}
        <div className="md:mr-[60px] py-[15px]">
          <SectionLabel text="Make your vision come true" className="text-white" />
          <h2
            className="text-[32px] md:text-[40px] font-normal text-white font-heading leading-[1.08] mb-6"
          >
            {t('headline')}
          </h2>
          <p className="text-[14px] text-white font-sans leading-[1.56] mb-10">
            {t('description')}
          </p>
          <div className="flex flex-col sm:flex-row items-start gap-4">
            <Link
              href="/life-at-simisi"
              className="inline-flex items-center bg-white text-navy text-[14px] font-semibold px-[25px] py-[11px] rounded-[25px] hover:bg-primary hover:text-white transition-all duration-300"
            >

              {t('ctaPrimary')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
